<template>
  <div class="notfound">
    <img src="../assets/images/404.png" />
    <div class="message">{{ message }}</div>
      <el-link href="/">返回首页</el-link>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: '可能原因：页面是否已发布 | 链接地址是否正确'
    }
  }
}
</script>

<style lang="stylus" scoped>
.notfound
  display flex
  justify-content center
  align-items center
  flex-direction column
  padding 150px 0 40px 0
/deep/.el-link
  display inline-block
  line-height 1
  white-space nowrap
  cursor pointer
  background #FFF
  border 1px solid #DCDFE6
  color #606266
  -webkit-appearance none
  text-align center
  box-sizing border-box
  outline 0
  margin 10px 0 0 0
  transition 0.1s
  font-weight 500
  padding 9px 15px
  font-size 12px
  border-radius 3px
/deep/.el-link.is-underline:hover:after
  position absolute
  left 0
  right 0
  height 0
  bottom 0
  border-bottom none
.message
  color $conventional-text
  font-size 18px
  // font-weight 550
  margin-bottom 20px
  // line-height 50px
</style>
